import {CONSTANTS} from '@/constants';
import { functions } from '@/functions';

export const functions_hotel = {

    data: function () {
        return {
            hotel:null,
            hotels:[],
            hotels_loaded:false,
        };
    },

    computed: {
        booker_id: {
            set: function (val) {
                this.hotel.extern_disabled = (val===0);
            },
            get: function () {
                return this.hotel.extern_disabled ? 0 : 1;
            },
        },
        booker_hotel_id: {
            set: function (val) {
                this.hotel.prof_obj_items_id = val;
            },
            get: function () {
                return this.hotel.prof_obj_items_id;
            },
        },
    },

    methods: {
        /*
        *  Отели
        */

        loadCityHotels: function (city_id, onSuccess=null, param=null) {
            if (!this.isHotelsLoaded() && city_id) {
                this.hotels_loaded = false;
                this.httpPrepare();
                this.$http.get(this.apiurl('city/' + city_id + '/hotels/a')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.hotels = response.payload;
                    this.hotels_loaded = true;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        loadHotels: function (onSuccess=null, param=null) {
            //console.log('loadHotels');
            if (this.isHotelsPreloaded()) { this.executeFunction(onSuccess, param); return this; }
            this.hotels_loaded = false;
            this.hotels = [];
            this.httpPrepare();
            this.$http.get(this.apiurl('hotel')).then(function (response) {
                response = this.httpSuccess(response);
                this.hotels = response.payload;
                this.$store.commit('savePreloadHotels', this.hotels);
                this.hotels_loaded = true;
                this.executeFunction(onSuccess, param);
            }, this.httpError);
            return this;
        },


        resetHotels: function () {
            this.hotels = [];
            return this;
        },

        isHotelsLoaded: function () {
            return this.is(this.hotels) && this.hotels.length;
        },

        isHotelsPreloaded: function () {
            if (!this.is(this.$store.state.pl.hotels)) { return false; }
            this.hotels = this.$store.state.pl.hotels;
            return true;
        },

        getHotelById: function (id, hotels=null) {
            if (!this.is(hotels)) {
                hotels = this.hotels;
            }
            console.log('this', this)
            console.log('this.hotels', hotels)
            console.log('id', id)
            return this.findElementByID(hotels, id);
            // if (!this.is(id)) {
            //     return 'не указано';
            // }
            //
            // for (let i=0; i<this.hotels.length; i++) {
            //     if (this.hotels[i].id === id) {
            //         return this.hotels[i];
            //     }
            // }
            //
            // return null;
        },

        deleteHotelImage: function(imageId, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.delete(this.apiurl('hotel/image/' + imageId + '/delete')).then(function (response) {
                response = this.httpSuccess(response);
                if (response.result === 'success') {
                    console.log(response);
                    this.executeFunction(onSuccess, param);
                }
                else {
                    this.error_log(response.error);
                }
            }, this.httpError)
        },

        /*
         * Отель
         */

        loadHotel: function (hotel_id, onSuccess=null, param=null) {
            if (hotel_id) {
                this.hotel = null;
                this.httpPrepare();
                this.$http.get(this.apiurl('hotel/' + hotel_id )).then(function (response) {
                    response = this.httpSuccess(response);
                    this.hotel = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        loadHotelAll: function (hotel_id, onSuccess=null, param=null) {
            if (!this.isHotelLoaded() && hotel_id) {
                this.hotel = null;
                this.httpPrepare();
                this.$http.get(this.apiurl('hotel/' + hotel_id + '/all' )).then(function (response) {
                    response = this.httpSuccess(response);
                    this.hotel = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        loadHotelImages: function (onSuccess=null, param=null) {
            if (this.isHotelLoaded()) {
                this.httpPrepare();
                this.$http.get(this.apiurl('hotel/' + this.hotel.id + '/private')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.hotel.images = _.cloneDeep(response.payload.images);
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        isHotelLoaded: function () {
            return this.is(this.hotel);
        },

        resetHotel: function () {
            this.hotel = null;
            return this;
        },

        saveHotel: function (onSuccess=null, param) {
            this.httpPrepare();
            this.$http.put(this.apiurl('hotel/'+this.hotel.id+'/save'), this.hotel).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
                this.setLatestHotel(this.hotel.id);
            }, this.httpError)
        },

        isExternalBooker: function(hotel) {
            return !hotel.extern_disabled;
        },

        externalBookerName: function(hotel) {
            if (hotel.extern_disabled) {
                return 'НСБ';
            }
            else {
                return 'Профкурорт';
            }
        },


        enableHotel: function (hotel_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('hotel/' + hotel_id + '/enable' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        disableHotel: function (hotel_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('hotel/' + hotel_id + '/disable' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        deleteHotel: function (hotel_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.delete(this.apiurl('hotel/' + hotel_id + '/delete' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        createHotel: function (onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('hotel/create')).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
                this.setLatestHotel(response.payload.id);
            }, this.httpError)
        },

        latestHotelClass: function (hotel) {
            return this.isLatest('App\\Models\\Hotel', hotel.id) ? 'latest' : '';
        },

        setLatestHotel: function (id) {
            this.setLatest('App\\Models\\Hotel', id);
        },

    },
};

